/* ==========================================================================
   Terravé : barre de filtres horizontale.

   Ce fichier ne filtre rien. Il fait deux choses :
     1. ouvre et ferme les menus deroulants de la barre ;
     2. delegue les clics sur les liens de facette a <collection-filters-form>,
        exactement comme le fait facet-remove.js de Minimog.

   Toute la mecanique (Section Rendering API, historique, cache) reste celle du
   theme. Si ce fichier ne se charge pas, les liens fonctionnent quand meme :
   ce sont de vrais href, la page se recharge simplement.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.customElements) return;

  /* ---------- 1. Delegation des liens de facette ------------------------ */

  if (!window.customElements.get('tv-facet-link')) {
    window.customElements.define(
      'tv-facet-link',
      class extends HTMLElement {
        connectedCallback() {
          var link = this.querySelector('a');
          if (!link) return;

          link.addEventListener('click', function (event) {
            var form =
              link.closest('collection-filters-form') ||
              document.querySelector('collection-filters-form');
            // Pas de formulaire de filtres : on laisse le lien faire son travail.
            if (!form || typeof form.renderPage !== 'function') return;

            event.preventDefault();
            form.renderPage(new URL(link.href, window.location.origin).searchParams.toString());
          });
        }
      }
    );
  }

  /* ---------- 2. Menus deroulants de la barre --------------------------- */

  if (!window.customElements.get('tv-filter-bar')) {
    window.customElements.define(
      'tv-filter-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);

          this.addEventListener('click', (event) => {
            var trigger = event.target.closest('[data-facet-trigger]');
            if (!trigger) return;
            var open = trigger.getAttribute('aria-expanded') === 'true';
            this.closeAll();
            if (!open) this.open(trigger);
          });

          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeydown);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeydown);
        }

        open(trigger) {
          var panel = this.querySelector('#' + CSS.escape(trigger.getAttribute('aria-controls')));
          if (!panel) return;
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
          this.classList.add('is-open');
        }

        closeAll() {
          this.querySelectorAll('[data-facet-trigger]').forEach(function (t) {
            t.setAttribute('aria-expanded', 'false');
          });
          this.querySelectorAll('[data-facet-panel]').forEach(function (p) {
            p.hidden = true;
          });
          this.classList.remove('is-open');
        }

        onDocumentClick(event) {
          if (!this.contains(event.target)) this.closeAll();
        }

        onKeydown(event) {
          if (event.key !== 'Escape') return;
          var openTrigger = this.querySelector('[data-facet-trigger][aria-expanded="true"]');
          this.closeAll();
          if (openTrigger) openTrigger.focus();
        }
      }
    );
  }
})();
